
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/power-kits/recommend",
      function () {
        return require("private-next-pages/power-kits/recommend/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/power-kits/recommend"])
      });
    }
  